export const FETCH_GOALS_REQUEST = 'FETCH_GOALS_REQUEST';
export const FETCH_GOALS_SUCCESS = 'FETCH_GOALS_SUCCESS';
export const FETCH_GOALS_FAILURE = 'FETCH_GOALS_FAILURE';
export const CREATE_GOALS_REQUEST = 'CREATE_GOALS_REQUEST';
export const CREATE_GOALS_SUCCESS = 'CREATE_GOALS_SUCCESS';
export const CREATE_GOALS_FAILURE = 'CREATE_GOALS_FAILURE';
